export const meta = {
  title: 'Papan giliran: urus barisan tanpa papan putih',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'pos', 'staff'],
};

Papan giliran ialah nadi papan pemuka anda. Ia dikemas kini secara langsung pada setiap peranti yang membukanya — kaunter juruwang, tablet pencuci, telefon anda.

## Tiga lajur

Setiap tiket aktif berada dalam salah satu daripada tiga lajur:

- **Dalam giliran** — sudah ditempah, menunggu ruang cucian. Tiket memaparkan kedudukan dalam barisan.
- **Sedang dicuci** — sedang dicuci sekarang.
- **Sedia untuk diambil** — sudah dicuci, menunggu pelanggan membayar dan mengambil.

Setiap kad memaparkan nombor tiket, pakej, plat, dan jumlah. Jika lajur giliran kosong, tiada apa yang perlu diurus — tempahan baharu muncul serta-merta apabila pelanggan mengimbas QR anda.

## Mula seterusnya

Butang **Mula seterusnya** berada di bahagian atas lajur Dalam giliran dan sentiasa menamakan tiket paling hadapan. Satu tekanan memindahkan tiket itu ke cucian. Kalau pencuci anda hanya mahu guna satu butang sahaja, inilah dia.

Anda juga boleh menekan **Mula** pada mana-mana kad untuk memasukkan kereta tertentu dahulu — fungsinya sama, cuma tidak semestinya yang di hadapan barisan.

## Menyusun semula barisan

Setiap kad dalam lajur Dalam giliran ada **anak panah atas dan bawah** di tepi kirinya. Setiap tekanan mengalihkan tiket satu tempat. Kedudukan pelanggan dikemas kini serta-merta dalam aplikasi mereka.

Tiada seret-dan-lepas — pada tablet berjari basah, tekanan tunggal yang disengajakan lebih baik daripada seretan tidak sengaja.

## Tahan dan sambung semula

Pelanggan menempah, kemudian keluar makan tengah hari? Tekan **Tahan** pada kad mereka. Tiket keluar dari barisan dan diletakkan dalam bahagian **Ditahan** di bawah lajur Dalam giliran, jadi kereta di belakangnya naik ke hadapan.

Apabila pelanggan kembali, tekan **Sambung**. Tiket itu masuk semula ke giliran **di hujung barisan** — bukan tempat asalnya. Jika anda mahu berikan keutamaan, naikkannya dengan anak panah atas. Ini disengajakan: mereka yang terus menunggu tidak patut hilang tempat secara senyap.

## Siap, diambil, dibatalkan

- **Siap** memindahkan tiket yang sedang dicuci ke Sedia untuk diambil dan memberitahu pelanggan kereta mereka sudah siap.
- **Diambil** ialah tekanan terakhir — ia mengarkibkan tiket ke dalam sejarah, tempat laporan dan program kesetiaan mengambilnya. Pembayaran disahkan di skrin POS.
- **Batal** tersedia semasa tiket dalam giliran, sedang dicuci, atau ditahan. Tiket yang sedia untuk diambil tidak boleh dibatalkan dari papan — selesaikan di POS.

## Lebih daripada satu outlet?

**Penukar outlet** di bahagian atas papan menukar seluruh paparan antara lokasi anda. Setiap outlet ada gilirannya sendiri, kod QR sendiri, dan nombor tiketnya sendiri.

## Apa yang pelanggan nampak

Setiap tindakan anda di papan terpapar dalam aplikasi pelanggan. Mereka nampak kedudukan dalam barisan, dan menerima notifikasi pada setiap langkah — ketika masuk giliran, ketika cucian bermula, ketika kereta siap, dan jika anda menahan atau membatalkan tiket mereka. Tidak perlu lagi menjerit nombor plat merentasi lot.
